var items = {
  "block.minecraft.air": "воздухъ",
  "block.minecraft.stone": "камень",
  "block.minecraft.granite": "гранитъ",
  "block.minecraft.polished_granite": "полированный гранитъ",
  "block.minecraft.diorite": "діоритъ",
  "block.minecraft.polished_diorite": "полированный діоритъ",
  "block.minecraft.andesite": "андезитъ",
  "block.minecraft.polished_andesite": "полированный андезитъ",
  "block.minecraft.grass_block": "дернина",
  "block.minecraft.dirt": "земля",
  "block.minecraft.coarse_dirt": "каменистая земля",
  "block.minecraft.podzol": "подзолъ",
  "block.minecraft.crimson_nylium": "багровый нилій",
  "block.minecraft.warped_nylium": "искажённый нилій",
  "block.minecraft.cobblestone": "булыжникъ",
  "block.minecraft.oak_planks": "дубовыя доски",
  "block.minecraft.spruce_planks": "еловыя доски",
  "block.minecraft.birch_planks": "берёзовыя доски",
  "block.minecraft.jungle_planks": "доски изъ тропическаго дерева",
  "block.minecraft.acacia_planks": "акаціевыя доски",
  "block.minecraft.dark_oak_planks": "доски изъ тёмнаго дуба",
  "block.minecraft.crimson_planks": "багровыя доски",
  "block.minecraft.warped_planks": "искажённыя доски",
  "block.minecraft.oak_sapling": "саженецъ дуба",
  "block.minecraft.spruce_sapling": "саженецъ ели",
  "block.minecraft.birch_sapling": "саженецъ берёзы",
  "block.minecraft.jungle_sapling": "саженецъ тропическаго дерева",
  "block.minecraft.acacia_sapling": "саженецъ акаціи",
  "block.minecraft.dark_oak_sapling": "саженецъ тёмнаго дуба",
  "block.minecraft.bedrock": "коренная порода",
  "block.minecraft.sand": "песокъ",
  "block.minecraft.red_sand": "червонный песокъ",
  "block.minecraft.gravel": "гравій",
  "block.minecraft.gold_ore": "золотая руда",
  "block.minecraft.iron_ore": "желѣзная руда",
  "block.minecraft.coal_ore": "угольная руда",
  "block.minecraft.nether_gold_ore": "нѣдрская золотая руда",
  "block.minecraft.oak_log": "дубовое бревно",
  "block.minecraft.spruce_log": "еловое бревно",
  "block.minecraft.birch_log": "берёзовое бревно",
  "block.minecraft.jungle_log": "бревно тропическаго дерева",
  "block.minecraft.acacia_log": "бревно акаціи",
  "block.minecraft.dark_oak_log": "бревно тёмнаго дуба",
  "block.minecraft.crimson_stem": "багровый стебель",
  "block.minecraft.warped_stem": "искажённый стебель",
  "block.minecraft.stripped_oak_log": "обтёсанное дубовое бревно",
  "block.minecraft.stripped_spruce_log": "обтёсанное еловое бревно",
  "block.minecraft.stripped_birch_log": "обтёсанное берёзовое бревно",
  "block.minecraft.stripped_jungle_log": "обтёсанное бревно тропическаго дерева",
  "block.minecraft.stripped_acacia_log": "обтёсанное бревно акаціи",
  "block.minecraft.stripped_dark_oak_log": "обтёсанное бревно тёмнаго дуба",
  "block.minecraft.stripped_crimson_stem": "очищенный багровый стебель",
  "block.minecraft.stripped_warped_stem": "обтесанный искажённый стебель",
  "block.minecraft.stripped_oak_wood": "обтёсанная дубовая древесина",
  "block.minecraft.stripped_spruce_wood": "обтёсанная еловая древесина",
  "block.minecraft.stripped_birch_wood": "обтёсанная берёзовая древесина",
  "block.minecraft.stripped_jungle_wood": "обтёсанная тропическая древесина",
  "block.minecraft.stripped_acacia_wood": "обтёсанная акаціевая древесина",
  "block.minecraft.stripped_dark_oak_wood": "обтёсанная древесина тёмнаго дуба",
  "block.minecraft.stripped_crimson_hyphae": "очищенные багровые гифы",
  "block.minecraft.stripped_warped_hyphae": "очищенные искажённые гифы",
  "block.minecraft.oak_wood": "дубъ",
  "block.minecraft.spruce_wood": "ель",
  "block.minecraft.birch_wood": "берёза",
  "block.minecraft.jungle_wood": "тропическое дерево",
  "block.minecraft.acacia_wood": "акація",
  "block.minecraft.dark_oak_wood": "тёмный дубъ",
  "block.minecraft.crimson_hyphae": "багровые гифы",
  "block.minecraft.warped_hyphae": "искажённые гифы",
  "block.minecraft.oak_leaves": "дубовые листья",
  "block.minecraft.spruce_leaves": "хвоя",
  "block.minecraft.birch_leaves": "берёзовые листья",
  "block.minecraft.jungle_leaves": "листья тропическаго дерева",
  "block.minecraft.acacia_leaves": "листья акаціи",
  "block.minecraft.dark_oak_leaves": "листья тёмнаго дуба",
  "block.minecraft.sponge": "губка",
  "block.minecraft.wet_sponge": "мокрая губка",
  "block.minecraft.glass": "стекло",
  "block.minecraft.lapis_ore": "лазуриковая руда",
  "block.minecraft.lapis_block": "лазуриковый блокъ",
  "block.minecraft.dispenser": "раздатчикъ",
  "block.minecraft.sandstone": "песчаникъ",
  "block.minecraft.chiseled_sandstone": "декоративный песчаникъ",
  "block.minecraft.cut_sandstone": "рѣзной песчаникъ",
  "block.minecraft.note_block": "музыкальный блокъ",
  "block.minecraft.powered_rail": "запитанные рельсы",
  "block.minecraft.detector_rail": "сигнальные рельсы",
  "block.minecraft.sticky_piston": "липкій поршень",
  "block.minecraft.cobweb": "паутина",
  "block.minecraft.grass": "трава",
  "block.minecraft.fern": "папоротникъ",
  "block.minecraft.dead_bush": "мёртвый кустъ",
  "block.minecraft.seagrass": "водоросли",
  "block.minecraft.sea_pickle": "морской огурецъ",
  "block.minecraft.piston": "поршень",
  "block.minecraft.white_wool": "бѣлая шерсть",
  "block.minecraft.orange_wool": "оранжевая шерсть",
  "block.minecraft.magenta_wool": "пурпурная шерсть",
  "block.minecraft.light_blue_wool": "голубая шерсть",
  "block.minecraft.yellow_wool": "жёлтая шерсть",
  "block.minecraft.lime_wool": "яркозелёная шерсть",
  "block.minecraft.pink_wool": "розовая шерсть",
  "block.minecraft.gray_wool": "сѣрая шерсть",
  "block.minecraft.light_gray_wool": "свѣтлосѣрая шерсть",
  "block.minecraft.cyan_wool": "бирюзовая шерсть",
  "block.minecraft.purple_wool": "фіолетовая шерсть",
  "block.minecraft.blue_wool": "лазурная шерсть",
  "block.minecraft.brown_wool": "коричневая шерсть",
  "block.minecraft.green_wool": "зелёная шерсть",
  "block.minecraft.red_wool": "червонная шерсть",
  "block.minecraft.black_wool": "чёрная шерсть",
  "block.minecraft.dandelion": "одуванчикъ",
  "block.minecraft.poppy": "макъ",
  "block.minecraft.blue_orchid": "лазурная орхидея",
  "block.minecraft.allium": "лукъ-батунъ",
  "block.minecraft.azure_bluet": "голубой василёкъ",
  "block.minecraft.red_tulip": "червонный тюльпанъ",
  "block.minecraft.orange_tulip": "оранжевый тюльпанъ",
  "block.minecraft.white_tulip": "бѣлый тюльпанъ",
  "block.minecraft.pink_tulip": "розовый тюльпанъ",
  "block.minecraft.oxeye_daisy": "ромашка",
  "block.minecraft.cornflower": "синій василёкъ",
  "block.minecraft.lily_of_the_valley": "ландышъ",
  "block.minecraft.wither_rose": "роза визера",
  "block.minecraft.brown_mushroom": "моховикъ",
  "block.minecraft.red_mushroom": "мухоморъ",
  "block.minecraft.crimson_fungus": "багровый грибъ",
  "block.minecraft.warped_fungus": "искажённый грибъ",
  "block.minecraft.crimson_roots": "багровые корни",
  "block.minecraft.warped_roots": "искажённые корни",
  "block.minecraft.nether_sprouts": "ростки нѣдра",
  "block.minecraft.weeping_vines": "плакучая лоза",
  "block.minecraft.twisting_vines": "вьющаяся лоза",
  "block.minecraft.sugar_cane": "сахарный тростникъ",
  "block.minecraft.kelp": "ламинаріи",
  "block.minecraft.bamboo": "бамбукъ",
  "block.minecraft.gold_block": "золотой блокъ",
  "block.minecraft.iron_block": "желѣзный блокъ",
  "block.minecraft.oak_slab": "дубовая плита",
  "block.minecraft.spruce_slab": "еловая плита",
  "block.minecraft.birch_slab": "берёзовая плита",
  "block.minecraft.jungle_slab": "плита изъ тропическаго дерева",
  "block.minecraft.acacia_slab": "акаціевая плита",
  "block.minecraft.dark_oak_slab": "плита изъ тёмнаго дуба",
  "block.minecraft.crimson_slab": "багровая плита",
  "block.minecraft.warped_slab": "искажённая плита",
  "block.minecraft.stone_slab": "каменная плита",
  "block.minecraft.smooth_stone_slab": "плита изъ гладкаго камня",
  "block.minecraft.sandstone_slab": "песчаниковая плита",
  "block.minecraft.cut_sandstone_slab": "плита изъ рѣзного песчаника",
  "block.minecraft.petrified_oak_slab": "окаменѣвшая дубовая плита",
  "block.minecraft.cobblestone_slab": "булыжная плита",
  "block.minecraft.brick_slab": "кирпичная плита",
  "block.minecraft.stone_brick_slab": "плита изъ каменнаго кирпича",
  "block.minecraft.nether_brick_slab": "нѣдрская плита",
  "block.minecraft.quartz_slab": "кварцевая плита",
  "block.minecraft.red_sandstone_slab": "плита изъ червоннаго песчаника",
  "block.minecraft.cut_red_sandstone_slab": "плита изъ рѣзного червоннаго песчаника",
  "block.minecraft.purpur_slab": "пурпуровая плита",
  "block.minecraft.prismarine_slab": "призмариновая плита",
  "block.minecraft.prismarine_brick_slab": "плита изъ призмариноваго кирпича",
  "block.minecraft.dark_prismarine_slab": "плита изъ тёмнаго призмарина",
  "block.minecraft.smooth_quartz": "гладкій нѣдрскій кварцъ",
  "block.minecraft.smooth_red_sandstone": "гладкій червонный песчаникъ",
  "block.minecraft.smooth_sandstone": "гладкій песчаникъ",
  "block.minecraft.smooth_stone": "гладкій камень",
  "block.minecraft.bricks": "кирпичи",
  "block.minecraft.tnt": "динамитъ",
  "block.minecraft.bookshelf": "книжная полка",
  "block.minecraft.mossy_cobblestone": "мшистый булыжникъ",
  "block.minecraft.obsidian": "обсидіанъ",
  "block.minecraft.torch": "факелъ",
  "block.minecraft.end_rod": "стержень энда",
  "block.minecraft.chorus_plant": "хорусъ",
  "block.minecraft.chorus_flower": "цвѣтокъ хоруса",
  "block.minecraft.purpur_block": "пурпуръ",
  "block.minecraft.purpur_pillar": "пурпуровый пилонъ",
  "block.minecraft.purpur_stairs": "пурпуровыя ступеньки",
  "block.minecraft.spawner": "разсадникъ",
  "block.minecraft.oak_stairs": "дубовыя ступеньки",
  "block.minecraft.chest": "сундукъ",
  "block.minecraft.diamond_ore": "діамантовая руда",
  "block.minecraft.diamond_block": "діамантовый блокъ",
  "block.minecraft.crafting_table": "верстакъ",
  "block.minecraft.farmland": "пашня",
  "block.minecraft.furnace": "печь",
  "block.minecraft.ladder": "лѣстница",
  "block.minecraft.rail": "рельсы",
  "block.minecraft.cobblestone_stairs": "булыжныя ступеньки",
  "block.minecraft.lever": "рычагъ",
  "block.minecraft.stone_pressure_plate": "каменная нажимная плита",
  "block.minecraft.oak_pressure_plate": "дубовая нажимная плита",
  "block.minecraft.spruce_pressure_plate": "еловая нажимная плита",
  "block.minecraft.birch_pressure_plate": "берёзовая нажимная плита",
  "block.minecraft.jungle_pressure_plate": "нажимная плита изъ тропическаго дерева",
  "block.minecraft.acacia_pressure_plate": "акаціевая нажимная плита",
  "block.minecraft.dark_oak_pressure_plate": "нажимная плита изъ тёмнаго дуба",
  "block.minecraft.crimson_pressure_plate": "багровая нажимная плита",
  "block.minecraft.warped_pressure_plate": "искажённая нажимная плита",
  "block.minecraft.polished_blackstone_pressure_plate": "нажимная плита изъ полированнаго чернокамня",
  "block.minecraft.redstone_ore": "редстоуновая руда",
  "block.minecraft.redstone_torch": "редстоуновый факелъ",
  "block.minecraft.snow": "снѣгъ",
  "block.minecraft.ice": "лёдъ",
  "block.minecraft.snow_block": "блокъ снѣга",
  "block.minecraft.cactus": "кактусъ",
  "block.minecraft.clay": "глина",
  "block.minecraft.jukebox": "патефонъ",
  "block.minecraft.oak_fence": "дубовый заборъ",
  "block.minecraft.spruce_fence": "еловый заборъ",
  "block.minecraft.birch_fence": "берёзовый заборъ",
  "block.minecraft.jungle_fence": "заборъ изъ тропическаго дерева",
  "block.minecraft.acacia_fence": "акаціевый заборъ",
  "block.minecraft.dark_oak_fence": "заборъ изъ тёмнаго дуба",
  "block.minecraft.crimson_fence": "багровый заборъ",
  "block.minecraft.warped_fence": "искажённый заборъ",
  "block.minecraft.pumpkin": "тыква",
  "block.minecraft.carved_pumpkin": "рѣзная тыква",
  "block.minecraft.netherrack": "нѣдракъ",
  "block.minecraft.soul_sand": "песокъ душъ",
  "block.minecraft.soul_soil": "почва душъ",
  "block.minecraft.basalt": "базальтъ",
  "block.minecraft.polished_basalt": "полированный базальтъ",
  "block.minecraft.soul_torch": "факелъ душъ",
  "block.minecraft.glowstone": "свѣтокамень",
  "block.minecraft.jack_o_lantern": "свѣтильникъ джека",
  "block.minecraft.oak_trapdoor": "дубовый люкъ",
  "block.minecraft.spruce_trapdoor": "еловый люкъ",
  "block.minecraft.birch_trapdoor": "берёзовый люкъ",
  "block.minecraft.jungle_trapdoor": "люкъ изъ тропическаго дерева",
  "block.minecraft.acacia_trapdoor": "акаціевый люкъ",
  "block.minecraft.dark_oak_trapdoor": "люкъ изъ тёмнаго дуба",
  "block.minecraft.crimson_trapdoor": "багровый люкъ",
  "block.minecraft.warped_trapdoor": "искажённый люкъ",
  "block.minecraft.infested_stone": "заражённый камень",
  "block.minecraft.infested_cobblestone": "заражённый булыжникъ",
  "block.minecraft.infested_stone_bricks": "заражённые каменные кирпичи",
  "block.minecraft.infested_mossy_stone_bricks": "заражённые мшистые каменные кирпичи",
  "block.minecraft.infested_cracked_stone_bricks": "заражённые потрескавшіеся каменные кирпичи",
  "block.minecraft.infested_chiseled_stone_bricks": "заражённые рѣзные каменные кирпичи",
  "block.minecraft.stone_bricks": "каменные кирпичи",
  "block.minecraft.mossy_stone_bricks": "мшистые каменные кирпичи",
  "block.minecraft.cracked_stone_bricks": "потрескавшіеся каменные кирпичи",
  "block.minecraft.chiseled_stone_bricks": "рѣзные каменные кирпичи",
  "block.minecraft.brown_mushroom_block": "блокъ моховика",
  "block.minecraft.red_mushroom_block": "блокъ мухомора",
  "block.minecraft.mushroom_stem": "ножка гриба",
  "block.minecraft.iron_bars": "желѣзная рѣшётка",
  "block.minecraft.chain": "цѣпь",
  "block.minecraft.glass_pane": "стеклянная панель",
  "block.minecraft.melon": "арбузъ",
  "block.minecraft.vine": "ліаны",
  "block.minecraft.oak_fence_gate": "дубовая калитка",
  "block.minecraft.spruce_fence_gate": "еловая калитка",
  "block.minecraft.birch_fence_gate": "берёзовая калитка",
  "block.minecraft.jungle_fence_gate": "калитка изъ тропическаго дерева",
  "block.minecraft.acacia_fence_gate": "акаціевая калитка",
  "block.minecraft.dark_oak_fence_gate": "калитка изъ тёмнаго дуба",
  "block.minecraft.crimson_fence_gate": "багровая калитка",
  "block.minecraft.warped_fence_gate": "искажённая калитка",
  "block.minecraft.brick_stairs": "кирпичныя ступеньки",
  "block.minecraft.stone_brick_stairs": "ступеньки изъ каменнаго кирпича",
  "block.minecraft.mycelium": "мицелій",
  "block.minecraft.lily_pad": "кувшинка",
  "block.minecraft.nether_bricks": "нѣдрскіе кирпичи",
  "block.minecraft.cracked_nether_bricks": "потрескавшіеся нѣдрскіе кирпичи",
  "block.minecraft.chiseled_nether_bricks": "рѣзные нѣдрскіе кирпичи",
  "block.minecraft.nether_brick_fence": "нѣдрскій заборъ",
  "block.minecraft.nether_brick_stairs": "нѣдрскіе ступеньки",
  "block.minecraft.enchanting_table": "чародѣйскій алтарь",
  "block.minecraft.end_portal_frame": "рамка вратъ въ эндъ",
  "block.minecraft.end_stone": "эндернякъ",
  "block.minecraft.end_stone_bricks": "эндерняковые кирпичи",
  "block.minecraft.dragon_egg": "яйцо змѣя",
  "block.minecraft.redstone_lamp": "редстоуновый фонарь",
  "block.minecraft.sandstone_stairs": "песчаниковыя ступеньки",
  "block.minecraft.emerald_ore": "смарагдовая руда",
  "block.minecraft.ender_chest": "эндеръ-ларецъ",
  "block.minecraft.tripwire_hook": "крюкъ",
  "block.minecraft.emerald_block": "смарагдовый блокъ",
  "block.minecraft.spruce_stairs": "еловыя ступеньки",
  "block.minecraft.birch_stairs": "берёзовыя ступеньки",
  "block.minecraft.jungle_stairs": "ступеньки изъ тропическаго дерева",
  "block.minecraft.crimson_stairs": "багровыя ступеньки",
  "block.minecraft.warped_stairs": "искажённыя ступеньки",
  "block.minecraft.command_block": "ариѳмометръ",
  "block.minecraft.beacon": "маякъ",
  "block.minecraft.cobblestone_wall": "булыжная ограда",
  "block.minecraft.mossy_cobblestone_wall": "мшистая булыжная ограда",
  "block.minecraft.brick_wall": "кирпичная ограда",
  "block.minecraft.prismarine_wall": "призмариновая ограда",
  "block.minecraft.red_sandstone_wall": "ограда изъ червоннаго песчаника",
  "block.minecraft.mossy_stone_brick_wall": "ограда изъ мшистаго каменнаго кирпича",
  "block.minecraft.granite_wall": "гранитная ограда",
  "block.minecraft.stone_brick_wall": "ограда изъ каменнаго кирпича",
  "block.minecraft.nether_brick_wall": "ограда изъ нѣдрскаго кирпича",
  "block.minecraft.andesite_wall": "андезитовая ограда",
  "block.minecraft.red_nether_brick_wall": "ограда изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.sandstone_wall": "песчаниковая ограда",
  "block.minecraft.end_stone_brick_wall": "ограда изъ эндерняковаго кирпича",
  "block.minecraft.diorite_wall": "діоритовая ограда",
  "block.minecraft.blackstone_wall": "чернокаменная ограда",
  "block.minecraft.polished_blackstone_wall": "ограда изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_brick_wall": "ограда изъ полированнаго чернокаменнаго кирпича",
  "block.minecraft.stone_button": "каменная кнопка",
  "block.minecraft.oak_button": "дубовая кнопка",
  "block.minecraft.spruce_button": "еловая кнопка",
  "block.minecraft.birch_button": "берёзовая кнопка",
  "block.minecraft.jungle_button": "кнопка изъ тропическаго дерева",
  "block.minecraft.acacia_button": "акаціевая кнопка",
  "block.minecraft.dark_oak_button": "кнопка изъ тёмнаго дуба",
  "block.minecraft.crimson_button": "багровая кнопка",
  "block.minecraft.warped_button": "искажённая кнопка",
  "block.minecraft.polished_blackstone_button": "кнопка изъ полированнаго чернокамня",
  "block.minecraft.anvil": "наковальня",
  "block.minecraft.chipped_anvil": "сколотая наковальня",
  "block.minecraft.damaged_anvil": "разбитая наковальня",
  "block.minecraft.trapped_chest": "сундукъ-ловушка",
  "block.minecraft.light_weighted_pressure_plate": "легковѣсная нажимная плита",
  "block.minecraft.heavy_weighted_pressure_plate": "тяжеловѣсная нажимная плита",
  "block.minecraft.daylight_detector": "датчикъ дневного свѣта",
  "block.minecraft.redstone_block": "редстоуновый блокъ",
  "block.minecraft.nether_quartz_ore": "нѣдръ-кварцевая руда",
  "block.minecraft.hopper": "пріёмная воронка",
  "block.minecraft.chiseled_quartz_block": "рѣзной кварцевый блокъ",
  "block.minecraft.quartz_block": "кварцевый блокъ",
  "block.minecraft.quartz_bricks": "кварцевые кирпичи",
  "block.minecraft.quartz_pillar": "кварцевая колонна",
  "block.minecraft.quartz_stairs": "кварцевыя ступеньки",
  "block.minecraft.activator_rail": "подающіе рельсы",
  "block.minecraft.dropper": "выбрасыватель",
  "block.minecraft.white_terracotta": "бѣлая керамика",
  "block.minecraft.orange_terracotta": "оранжевая керамика",
  "block.minecraft.magenta_terracotta": "пурпурная керамика",
  "block.minecraft.light_blue_terracotta": "голубая керамика",
  "block.minecraft.yellow_terracotta": "жёлтая керамика",
  "block.minecraft.lime_terracotta": "яркозелёная керамика",
  "block.minecraft.pink_terracotta": "розовая керамика",
  "block.minecraft.gray_terracotta": "сѣрая керамика",
  "block.minecraft.light_gray_terracotta": "свѣтлосѣрая керамика",
  "block.minecraft.cyan_terracotta": "бирюзовая керамика",
  "block.minecraft.purple_terracotta": "фіолетовая керамика",
  "block.minecraft.blue_terracotta": "лазурная керамика",
  "block.minecraft.brown_terracotta": "коричневая керамика",
  "block.minecraft.green_terracotta": "зелёная керамика",
  "block.minecraft.red_terracotta": "червонная керамика",
  "block.minecraft.black_terracotta": "чёрная керамика",
  "block.minecraft.barrier": "барьеръ",
  "block.minecraft.iron_trapdoor": "желѣзный люкъ",
  "block.minecraft.hay_block": "снопъ сѣна",
  "block.minecraft.white_carpet": "бѣлый ковёръ",
  "block.minecraft.orange_carpet": "оранжевый ковёръ",
  "block.minecraft.magenta_carpet": "пурпурный ковёръ",
  "block.minecraft.light_blue_carpet": "голубой ковёръ",
  "block.minecraft.yellow_carpet": "жёлтый ковёръ",
  "block.minecraft.lime_carpet": "яркозелёный ковёръ",
  "block.minecraft.pink_carpet": "розовый ковёръ",
  "block.minecraft.gray_carpet": "сѣрый ковёръ",
  "block.minecraft.light_gray_carpet": "свѣтлосѣрый ковёръ",
  "block.minecraft.cyan_carpet": "бирюзовый ковёръ",
  "block.minecraft.purple_carpet": "фіолетовый ковёръ",
  "block.minecraft.blue_carpet": "лазурный ковёръ",
  "block.minecraft.brown_carpet": "коричневый ковёръ",
  "block.minecraft.green_carpet": "зелёный ковёръ",
  "block.minecraft.red_carpet": "червонный ковёръ",
  "block.minecraft.black_carpet": "чёрный ковёръ",
  "block.minecraft.terracotta": "керамика",
  "block.minecraft.coal_block": "угольный блокъ",
  "block.minecraft.packed_ice": "плотный лёдъ",
  "block.minecraft.acacia_stairs": "акаціевыя ступеньки",
  "block.minecraft.dark_oak_stairs": "ступеньки изъ тёмнаго дуба",
  "block.minecraft.slime_block": "блокъ слизи",
  "block.minecraft.grass_path": "дорожка",
  "block.minecraft.sunflower": "подсолнухъ",
  "block.minecraft.lilac": "сирень",
  "block.minecraft.rose_bush": "кустъ розъ",
  "block.minecraft.peony": "піонъ",
  "block.minecraft.tall_grass": "высокая трава",
  "block.minecraft.large_fern": "раскидистый папоротникъ",
  "block.minecraft.white_stained_glass": "бѣлое стекло",
  "block.minecraft.orange_stained_glass": "оранжевое стекло",
  "block.minecraft.magenta_stained_glass": "пурпурное стекло",
  "block.minecraft.light_blue_stained_glass": "голубое стекло",
  "block.minecraft.yellow_stained_glass": "жёлтое стекло",
  "block.minecraft.lime_stained_glass": "яркозелёное стекло",
  "block.minecraft.pink_stained_glass": "розовое стекло",
  "block.minecraft.gray_stained_glass": "сѣрое стекло",
  "block.minecraft.light_gray_stained_glass": "свѣтлосѣрое стекло",
  "block.minecraft.cyan_stained_glass": "бирюзовое стекло",
  "block.minecraft.purple_stained_glass": "фіолетовое стекло",
  "block.minecraft.blue_stained_glass": "лазурное стекло",
  "block.minecraft.brown_stained_glass": "коричневое стекло",
  "block.minecraft.green_stained_glass": "зелёное стекло",
  "block.minecraft.red_stained_glass": "червонное стекло",
  "block.minecraft.black_stained_glass": "чёрное стекло",
  "block.minecraft.white_stained_glass_pane": "бѣлая стеклянная панель",
  "block.minecraft.orange_stained_glass_pane": "оранжевая стеклянная панель",
  "block.minecraft.magenta_stained_glass_pane": "пурпурная стеклянная панель",
  "block.minecraft.light_blue_stained_glass_pane": "голубая окрашенная стеклянная панель",
  "block.minecraft.yellow_stained_glass_pane": "жёлтая стеклянная панель",
  "block.minecraft.lime_stained_glass_pane": "яркозёленая окрашенная стеклянная панель",
  "block.minecraft.pink_stained_glass_pane": "розовая стеклянная панель",
  "block.minecraft.gray_stained_glass_pane": "сѣрая стеклянная панель",
  "block.minecraft.light_gray_stained_glass_pane": "свѣтлосѣрая стеклянная панель",
  "block.minecraft.cyan_stained_glass_pane": "бирюзовая стеклянная панель",
  "block.minecraft.purple_stained_glass_pane": "фіолетовая стеклянная панель",
  "block.minecraft.blue_stained_glass_pane": "лазурная стеклянная панель",
  "block.minecraft.brown_stained_glass_pane": "коричневая стеклянная панель",
  "block.minecraft.green_stained_glass_pane": "зелёная стеклянная панель",
  "block.minecraft.red_stained_glass_pane": "червонная стеклянная панель",
  "block.minecraft.black_stained_glass_pane": "чёрная стеклянная панель",
  "block.minecraft.prismarine": "призмаринъ",
  "block.minecraft.prismarine_bricks": "призмариновые кирпичи",
  "block.minecraft.dark_prismarine": "тёмный призмаринъ",
  "block.minecraft.prismarine_stairs": "призмариновыя ступеньки",
  "block.minecraft.prismarine_brick_stairs": "ступеньки изъ призмариновыхъ кирпичей",
  "block.minecraft.dark_prismarine_stairs": "ступеньки изъ тёмнаго призмарина",
  "block.minecraft.sea_lantern": "морской фонарь",
  "block.minecraft.red_sandstone": "червонный песчаникъ",
  "block.minecraft.chiseled_red_sandstone": "рѣзной червонный песчаникъ",
  "block.minecraft.cut_red_sandstone": "рѣзной червонный песчаникъ",
  "block.minecraft.red_sandstone_stairs": "ступеньки изъ червоннаго песчаника",
  "block.minecraft.repeating_command_block": "повторяющій ариѳмометръ",
  "block.minecraft.chain_command_block": "цѣпной ариѳмометръ",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "блокъ нѣдрскаго нароста",
  "block.minecraft.warped_wart_block": "блокъ искажённаго нароста",
  "block.minecraft.red_nether_bricks": "червонный нѣдрскій кирпичъ",
  "block.minecraft.bone_block": "костный блокъ",
  "block.minecraft.structure_void": "пустой блокъ",
  "block.minecraft.observer": "смотритель",
  "block.minecraft.shulker_box": "шалкеровый ящикъ",
  "block.minecraft.white_shulker_box": "бѣлый шалкеровый ящикъ",
  "block.minecraft.orange_shulker_box": "оранжевый шалкеровый ящикъ",
  "block.minecraft.magenta_shulker_box": "пурпурный шалкеровый ящикъ",
  "block.minecraft.light_blue_shulker_box": "голубой шалкеровый ящикъ",
  "block.minecraft.yellow_shulker_box": "жёлтый шалкеровый ящикъ",
  "block.minecraft.lime_shulker_box": "яркозелёный шалкеровый ящикъ",
  "block.minecraft.pink_shulker_box": "розовый шалкеровый ящикъ",
  "block.minecraft.gray_shulker_box": "сѣрый шалкеровый ящикъ",
  "block.minecraft.light_gray_shulker_box": "свѣтлосѣрый шалкеровый ящикъ",
  "block.minecraft.cyan_shulker_box": "бирюзовый шалкеровый ящикъ",
  "block.minecraft.purple_shulker_box": "фіолетовый шалкеровый ящикъ",
  "block.minecraft.blue_shulker_box": "лазурный шалкеровый ящикъ",
  "block.minecraft.brown_shulker_box": "коричневый шалкеровый ящикъ",
  "block.minecraft.green_shulker_box": "зелёный шалкеровый ящикъ",
  "block.minecraft.red_shulker_box": "червонный шалкеровый ящикъ",
  "block.minecraft.black_shulker_box": "чёрный шалкеровый ящикъ",
  "block.minecraft.white_glazed_terracotta": "бѣлая глазированная керамика",
  "block.minecraft.orange_glazed_terracotta": "оранжевая глазурованная керамика",
  "block.minecraft.magenta_glazed_terracotta": "пурпурная глазурованная керамика",
  "block.minecraft.light_blue_glazed_terracotta": "голубая глазурованная керамика",
  "block.minecraft.yellow_glazed_terracotta": "жёлтая глазурованная керамика",
  "block.minecraft.lime_glazed_terracotta": "яркозелёная глазурованная керамика",
  "block.minecraft.pink_glazed_terracotta": "розовая глазурованная керамика",
  "block.minecraft.gray_glazed_terracotta": "сѣрая глазурованная керамика",
  "block.minecraft.light_gray_glazed_terracotta": "свѣтлосѣрая глазурованная керамика",
  "block.minecraft.cyan_glazed_terracotta": "бирюзовая глазурованная керамика",
  "block.minecraft.purple_glazed_terracotta": "фіолетовая глазурованная керамика",
  "block.minecraft.blue_glazed_terracotta": "лазурная глазурованная керамика",
  "block.minecraft.brown_glazed_terracotta": "коричневая глазурованная керамика",
  "block.minecraft.green_glazed_terracotta": "зелёная глазурованная керамика",
  "block.minecraft.red_glazed_terracotta": "червонная глазурованная керамика",
  "block.minecraft.black_glazed_terracotta": "чёрная глазурованная керамика",
  "block.minecraft.white_concrete": "бѣлый бетонъ",
  "block.minecraft.orange_concrete": "оранжевый бетонъ",
  "block.minecraft.magenta_concrete": "пурпурный бетонъ",
  "block.minecraft.light_blue_concrete": "голубой бетонъ",
  "block.minecraft.yellow_concrete": "жёлтый бетонъ",
  "block.minecraft.lime_concrete": "яркозелёный бетонъ",
  "block.minecraft.pink_concrete": "розовый бетонъ",
  "block.minecraft.gray_concrete": "сѣрый бетонъ",
  "block.minecraft.light_gray_concrete": "свѣтлосѣрый бетонъ",
  "block.minecraft.cyan_concrete": "бирюзовый бетонъ",
  "block.minecraft.purple_concrete": "фіолетовый бетонъ",
  "block.minecraft.blue_concrete": "лазурный бетонъ",
  "block.minecraft.brown_concrete": "коричневый бетонъ",
  "block.minecraft.green_concrete": "зелёный бетонъ",
  "block.minecraft.red_concrete": "червонный бетонъ",
  "block.minecraft.black_concrete": "чёрный бетонъ",
  "block.minecraft.white_concrete_powder": "бѣлый бетонный порошокъ",
  "block.minecraft.orange_concrete_powder": "оранжевый бетонный порошокъ",
  "block.minecraft.magenta_concrete_powder": "пурпурный бетонный порошокъ",
  "block.minecraft.light_blue_concrete_powder": "голубой бетонный порошокъ",
  "block.minecraft.yellow_concrete_powder": "жёлтый бетонный порошокъ",
  "block.minecraft.lime_concrete_powder": "яркозелёный бетонный порошокъ",
  "block.minecraft.pink_concrete_powder": "розовый бетонный порошокъ",
  "block.minecraft.gray_concrete_powder": "сѣрый бетонный порошокъ",
  "block.minecraft.light_gray_concrete_powder": "свѣтлосѣрый бетонный порошокъ",
  "block.minecraft.cyan_concrete_powder": "бирюзовый бетонный порошокъ",
  "block.minecraft.purple_concrete_powder": "фіолетовый бетонный порошокъ",
  "block.minecraft.blue_concrete_powder": "лазурный бетонный порошокъ",
  "block.minecraft.brown_concrete_powder": "коричневый бетонный порошокъ",
  "block.minecraft.green_concrete_powder": "зелёный бетонный порошокъ",
  "block.minecraft.red_concrete_powder": "червонный бетонный порошокъ",
  "block.minecraft.black_concrete_powder": "черный бетонный порошокъ",
  "block.minecraft.turtle_egg": "черепашье яйцо",
  "block.minecraft.dead_tube_coral_block": "блокъ мёртваго трубчатаго коралла",
  "block.minecraft.dead_brain_coral_block": "блокъ мёртваго коралла-мозговика",
  "block.minecraft.dead_bubble_coral_block": "блокъ мёртваго пузырчатаго коралла",
  "block.minecraft.dead_fire_coral_block": "блокъ мёртваго огненнаго коралла",
  "block.minecraft.dead_horn_coral_block": "блокъ мёртваго рогового коралла",
  "block.minecraft.tube_coral_block": "блокъ трубчатаго коралла",
  "block.minecraft.brain_coral_block": "блокъ коралла-мозговика",
  "block.minecraft.bubble_coral_block": "блокъ пузырчатаго коралла",
  "block.minecraft.fire_coral_block": "блокъ огненнаго коралла",
  "block.minecraft.horn_coral_block": "блокъ рогового коралла",
  "block.minecraft.tube_coral": "трубчатый кораллъ",
  "block.minecraft.brain_coral": "кораллъ-мозговикъ",
  "block.minecraft.bubble_coral": "пузырчатый кораллъ",
  "block.minecraft.fire_coral": "огненный кораллъ",
  "block.minecraft.horn_coral": "роговой кораллъ",
  "block.minecraft.dead_brain_coral": "мёртвый волнистый кораллъ",
  "block.minecraft.dead_bubble_coral": "мёртвый пузырчатый кораллъ",
  "block.minecraft.dead_fire_coral": "мёртвый огненный кораллъ",
  "block.minecraft.dead_horn_coral": "мёртвый роговой кораллъ",
  "block.minecraft.dead_tube_coral": "мёртвый трубчатый кораллъ",
  "block.minecraft.tube_coral_fan": "вѣерный трубчатый кораллъ",
  "block.minecraft.brain_coral_fan": "вѣерный кораллъ-мозговикъ",
  "block.minecraft.bubble_coral_fan": "вѣерный пузырчатый кораллъ",
  "block.minecraft.fire_coral_fan": "вѣерный огненный кораллъ",
  "block.minecraft.horn_coral_fan": "вѣерный роговой кораллъ",
  "block.minecraft.dead_tube_coral_fan": "мёртвый вѣерный трубчатый кораллъ",
  "block.minecraft.dead_brain_coral_fan": "мёртвый вѣерный волновой кораллъ",
  "block.minecraft.dead_bubble_coral_fan": "мёртвый вѣерный пузырчатый кораллъ",
  "block.minecraft.dead_fire_coral_fan": "мёртвый вѣерный огненный кораллъ",
  "block.minecraft.dead_horn_coral_fan": "мёртвый вѣерный роговой кораллъ",
  "block.minecraft.blue_ice": "синій лёдъ",
  "block.minecraft.conduit": "морской источникъ",
  "block.minecraft.polished_granite_stairs": "ступеньки изъ полированнаго гранита",
  "block.minecraft.smooth_red_sandstone_stairs": "ступеньки изъ гладкаго червоннаго песчаника",
  "block.minecraft.mossy_stone_brick_stairs": "ступеньки изъ мшистаго каменнаго кирпича",
  "block.minecraft.polished_diorite_stairs": "ступеньки изъ полированнаго діорита",
  "block.minecraft.mossy_cobblestone_stairs": "ступеньки изъ мшистаго булыжника",
  "block.minecraft.end_stone_brick_stairs": "ступеньки изъ эндерняковаго кирпича",
  "block.minecraft.stone_stairs": "каменныя ступеньки",
  "block.minecraft.smooth_sandstone_stairs": "ступеньки изъ гладкаго песчаника",
  "block.minecraft.smooth_quartz_stairs": "ступеньки изъ гладкаго кварца",
  "block.minecraft.granite_stairs": "гранитныя ступеньки",
  "block.minecraft.andesite_stairs": "андезитовыя ступеньки",
  "block.minecraft.red_nether_brick_stairs": "ступеньки изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.polished_andesite_stairs": "ступеньки изъ полированнаго андезита",
  "block.minecraft.diorite_stairs": "діоритовыя ступеньки",
  "block.minecraft.polished_granite_slab": "плита изъ полированнаго гранита",
  "block.minecraft.smooth_red_sandstone_slab": "плита изъ гладкаго червоннаго песчаника",
  "block.minecraft.mossy_stone_brick_slab": "плита изъ мшистаго каменнаго кирпича",
  "block.minecraft.polished_diorite_slab": "плита изъ полированнаго діорита",
  "block.minecraft.mossy_cobblestone_slab": "мшистая булыжная плита",
  "block.minecraft.end_stone_brick_slab": "плита изъ эндерняковаго кирпича",
  "block.minecraft.smooth_sandstone_slab": "плита изъ гладкаго песчаника",
  "block.minecraft.smooth_quartz_slab": "плита изъ гладкаго кварца",
  "block.minecraft.granite_slab": "гранитная плита",
  "block.minecraft.andesite_slab": "андезитовая плита",
  "block.minecraft.red_nether_brick_slab": "плита изъ червоннаго нѣдрскаго кирпича",
  "block.minecraft.polished_andesite_slab": "плита изъ полированнаго андезита",
  "block.minecraft.diorite_slab": "діоритовая плита",
  "block.minecraft.scaffolding": "строительные лѣса",
  "block.minecraft.iron_door": "желѣзная дверь",
  "block.minecraft.oak_door": "дубовая дверь",
  "block.minecraft.spruce_door": "еловая дверь",
  "block.minecraft.birch_door": "берёзовая дверь",
  "block.minecraft.jungle_door": "дверь изъ тропическаго дерева",
  "block.minecraft.acacia_door": "дверь изъ акаціи",
  "block.minecraft.dark_oak_door": "дверь изъ тёмнаго дуба",
  "block.minecraft.crimson_door": "багровая дверь",
  "block.minecraft.warped_door": "искажённая дверь",
  "block.minecraft.repeater": "редстоуновый повторитель",
  "block.minecraft.comparator": "редстоуновый сравниватель",
  "block.minecraft.structure_block": "структурный блокъ",
  "block.minecraft.jigsaw": "пазлъ",
  "item.minecraft.turtle_helmet": "черепашій панцырь□□когда надѣто на голову:□+2 броня",
  "item.minecraft.scute": "щитокъ",
  "item.minecraft.iron_shovel": "желѣзная лопата□□когда въ ведущей рукѣ:□+3.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.iron_pickaxe": "желѣзная кирка□□когда въ ведущей рукѣ:□+3 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.iron_axe": "желѣзный топоръ□□когда въ ведущей рукѣ:□+8 уронъ□-3.1 рѣзвость атаки",
  "item.minecraft.flint_and_steel": "огниво",
  "item.minecraft.apple": "яблоко",
  "item.minecraft.bow": "лукъ",
  "item.minecraft.arrow": "стрѣла",
  "item.minecraft.coal": "уголь",
  "item.minecraft.charcoal": "древесный уголь",
  "item.minecraft.diamond": "діамантъ",
  "item.minecraft.iron_ingot": "желѣзный слитокъ",
  "item.minecraft.gold_ingot": "золотой слитокъ",
  "item.minecraft.netherite_ingot": "нѣдритовый слитокъ",
  "item.minecraft.netherite_scrap": "нѣдритовый ломъ",
  "item.minecraft.iron_sword": "желѣзный мечъ□□когда въ ведущей рукѣ:□+5 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.wooden_sword": "деревянный мечъ□□когда въ ведущей рукѣ:□+3 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.wooden_shovel": "деревянная лопата□□когда въ ведущей рукѣ:□+1.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.wooden_pickaxe": "деревянная кирка□□когда въ ведущей рукѣ:□+1 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.wooden_axe": "деревянный топоръ□□когда въ ведущей рукѣ:□+6 уронъ□-3.2 рѣзвость атаки",
  "item.minecraft.stone_sword": "каменный мечъ□□когда въ ведущей рукѣ:□+4 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.stone_shovel": "каменная лопата□□когда въ ведущей рукѣ:□+2.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.stone_pickaxe": "каменная кирка□□когда въ ведущей рукѣ:□+2 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.stone_axe": "каменный топоръ□□когда въ ведущей рукѣ:□+8 уронъ□-3.2 рѣзвость атаки",
  "item.minecraft.diamond_sword": "діамантовый мечъ□□когда въ ведущей рукѣ:□+6 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.diamond_shovel": "діамантовая лопата□□когда въ ведущей рукѣ:□+4.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.diamond_pickaxe": "діамантовая кирка□□когда въ ведущей рукѣ:□+4 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.diamond_axe": "діамантовый топоръ□□когда въ ведущей рукѣ:□+8 уронъ□-3 рѣзвость атаки",
  "item.minecraft.stick": "палка",
  "item.minecraft.bowl": "миска",
  "item.minecraft.mushroom_stew": "грибной супъ",
  "item.minecraft.golden_sword": "золотой мечъ□□когда въ ведущей рукѣ:□+3 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.golden_shovel": "золотая лопата□□когда въ ведущей рукѣ:□+1.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.golden_pickaxe": "золотая кирка□□когда въ ведущей рукѣ:□+1 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.golden_axe": "золотой топоръ□□когда въ ведущей рукѣ:□+6 уронъ□-3 рѣзвость атаки",
  "item.minecraft.netherite_sword": "нѣдритовый мечъ□□когда въ ведущей рукѣ:□+7 уронъ□-2.4 рѣзвость атаки",
  "item.minecraft.netherite_shovel": "нѣдритовая лопата□□когда въ ведущей рукѣ:□+5.5 уронъ□-3 рѣзвость атаки",
  "item.minecraft.netherite_pickaxe": "нѣдритовая кирка□□когда въ ведущей рукѣ:□+5 уронъ□-2.8 рѣзвость атаки",
  "item.minecraft.netherite_axe": "нѣдритовый топоръ□□когда въ ведущей рукѣ:□+9 уронъ□-3 рѣзвость атаки",
  "item.minecraft.string": "нить",
  "item.minecraft.feather": "перо",
  "item.minecraft.gunpowder": "порохъ",
  "item.minecraft.wooden_hoe": "деревянная мотыга□□когда въ ведущей рукѣ:□-3 рѣзвость атаки",
  "item.minecraft.stone_hoe": "каменная мотыга□□когда въ ведущей рукѣ:□-2 рѣзвость атаки",
  "item.minecraft.iron_hoe": "желѣзная мотыга□□когда въ ведущей рукѣ:□-1 рѣзвость атаки",
  "item.minecraft.diamond_hoe": "діамантовая мотыга□□когда въ ведущей рукѣ:",
  "item.minecraft.golden_hoe": "золотая мотыга□□когда въ ведущей рукѣ:□-3 рѣзвость атаки",
  "item.minecraft.netherite_hoe": "нѣдритовая мотыга□□когда въ ведущей рукѣ:",
  "item.minecraft.wheat_seeds": "сѣмена пшеницы",
  "item.minecraft.wheat": "пшеница",
  "item.minecraft.bread": "хлѣбъ",
  "item.minecraft.leather_helmet": "кожаная шапка□□когда надѣто на голову:□+1 броня",
  "item.minecraft.leather_chestplate": "кожаная куртка□□когда надѣто:□+3 броня",
  "item.minecraft.leather_leggings": "кожаные гамаши□□когда надѣто на ноги:□+2 броня",
  "item.minecraft.leather_boots": "кожаные сапоги□□когда обуто:□+1 броня",
  "item.minecraft.chainmail_helmet": "койфъ□□когда надѣто на голову:□+2 броня",
  "item.minecraft.chainmail_chestplate": "кольчуга□□когда надѣто:□+5 броня",
  "item.minecraft.chainmail_leggings": "кольчужные поножи□□когда надѣто на ноги:□+4 броня",
  "item.minecraft.chainmail_boots": "кольчужные ботинки□□когда обуто:□+1 броня",
  "item.minecraft.iron_helmet": "желѣзный шлемъ□□когда надѣто на голову:□+2 броня",
  "item.minecraft.iron_chestplate": "желѣзный нагрудникъ□□когда надѣто:□+6 броня",
  "item.minecraft.iron_leggings": "желѣзные поножи□□когда надѣто на ноги:□+5 броня",
  "item.minecraft.iron_boots": "желѣзные ботинки□□когда обуто:□+2 броня",
  "item.minecraft.diamond_helmet": "діамантовый шлемъ□□когда надѣто на голову:□+3 броня□+2 твёрдость брони",
  "item.minecraft.diamond_chestplate": "діамантовый нагрудникъ□□когда надѣто:□+8 броня□+2 твёрдость брони",
  "item.minecraft.diamond_leggings": "діамантовые поножи□□когда надѣто на ноги:□+6 броня□+2 твёрдость брони",
  "item.minecraft.diamond_boots": "діамантовые ботинки□□когда обуто:□+3 броня□+2 твёрдость брони",
  "item.minecraft.golden_helmet": "золотой шлемъ□□когда надѣто на голову:□+2 броня",
  "item.minecraft.golden_chestplate": "золотой нагрудникъ□□когда надѣто:□+5 броня",
  "item.minecraft.golden_leggings": "золотые поножи□□когда надѣто на ноги:□+3 броня",
  "item.minecraft.golden_boots": "золотые ботинки□□когда обуто:□+1 броня",
  "item.minecraft.netherite_helmet": "нѣдритовый шлемъ□□когда надѣто на голову:□+3 броня□+3 твёрдость брони□+1 сопротивленіе отбрасыванію",
  "item.minecraft.netherite_chestplate": "нѣдритовый нагрудникъ□□когда надѣто:□+8 броня□+3 твёрдость брони□+1 сопротивленіе отбрасыванію",
  "item.minecraft.netherite_leggings": "нѣдритовые поножи□□когда надѣто на ноги:□+6 броня□+3 твёрдость брони□+1 сопротивленіе отбрасыванію",
  "item.minecraft.netherite_boots": "нѣдритовые ботинки□□когда обуто:□+3 броня□+3 твёрдость брони□+1 сопротивленіе отбрасыванію",
  "item.minecraft.flint": "кремень",
  "item.minecraft.porkchop": "сырая свинина",
  "item.minecraft.cooked_porkchop": "жареная свинина",
  "item.minecraft.painting": "картина",
  "item.minecraft.golden_apple": "золотое яблоко",
  "item.minecraft.enchanted_golden_apple": "молодильное яблоко",
  "block.minecraft.oak_sign": "дубовая табличка",
  "block.minecraft.spruce_sign": "еловая табличка",
  "block.minecraft.birch_sign": "берёзовая табличка",
  "block.minecraft.jungle_sign": "табличка изъ тропическаго дерева",
  "block.minecraft.acacia_sign": "акаціевая табличка",
  "block.minecraft.dark_oak_sign": "табличка изъ тёмнаго дуба",
  "block.minecraft.crimson_sign": "багровая табличка",
  "block.minecraft.warped_sign": "искажённая табличка",
  "item.minecraft.bucket": "ведро",
  "item.minecraft.water_bucket": "ведро воды",
  "item.minecraft.lava_bucket": "ведро лавы",
  "item.minecraft.minecart": "вагонетка",
  "item.minecraft.saddle": "сѣдло",
  "item.minecraft.redstone": "редстоунъ",
  "item.minecraft.snowball": "снѣжокъ",
  "item.minecraft.oak_boat": "дубовая лодка",
  "item.minecraft.leather": "кожа",
  "item.minecraft.milk_bucket": "ведро молока",
  "item.minecraft.pufferfish_bucket": "иглобрюхъ въ ведрѣ",
  "item.minecraft.salmon_bucket": "лосось въ ведрѣ",
  "item.minecraft.cod_bucket": "треска въ ведрѣ",
  "item.minecraft.tropical_fish_bucket": "тропическая рыба въ ведрѣ",
  "item.minecraft.brick": "кирпичъ",
  "item.minecraft.clay_ball": "комокъ глины",
  "block.minecraft.dried_kelp_block": "блокъ сушёной ламинаріи",
  "item.minecraft.paper": "бумага",
  "item.minecraft.book": "книга",
  "item.minecraft.slime_ball": "сгустокъ слизи",
  "item.minecraft.chest_minecart": "грузовая вагонетка",
  "item.minecraft.furnace_minecart": "самоходная вагонетка",
  "item.minecraft.egg": "яйцо",
  "item.minecraft.compass": "компасъ",
  "item.minecraft.fishing_rod": "удочка",
  "item.minecraft.clock": "часы",
  "item.minecraft.glowstone_dust": "свѣтокаменная пыль",
  "item.minecraft.cod": "сырая треска",
  "item.minecraft.salmon": "сырой лосось",
  "item.minecraft.tropical_fish": "тропическая рыба",
  "item.minecraft.pufferfish": "иглобрюхъ",
  "item.minecraft.cooked_cod": "жареная треска",
  "item.minecraft.cooked_salmon": "жареный лосось",
  "item.minecraft.ink_sac": "чернильный мѣшочекъ",
  "item.minecraft.red_dye": "червонный краситель",
  "item.minecraft.green_dye": "зелёный краситель",
  "item.minecraft.cocoa_beans": "какао-бобы",
  "item.minecraft.lapis_lazuli": "лазурикъ",
  "item.minecraft.purple_dye": "фіолетовый краситель",
  "item.minecraft.cyan_dye": "бирюзовый краситель",
  "item.minecraft.light_gray_dye": "свѣтлосѣрый краситель",
  "item.minecraft.gray_dye": "сѣрый краситель",
  "item.minecraft.pink_dye": "розовый краситель",
  "item.minecraft.lime_dye": "яркозелёный краситель",
  "item.minecraft.yellow_dye": "жёлтый краситель",
  "item.minecraft.light_blue_dye": "голубой краситель",
  "item.minecraft.magenta_dye": "пурпурный краситель",
  "item.minecraft.orange_dye": "оранжевый краситель",
  "item.minecraft.bone_meal": "костная мука",
  "item.minecraft.blue_dye": "лазурный краситель",
  "item.minecraft.brown_dye": "коричневый краситель",
  "item.minecraft.black_dye": "чёрный краситель",
  "item.minecraft.white_dye": "бѣлый краситель",
  "item.minecraft.bone": "кость",
  "item.minecraft.sugar": "сахаръ",
  "block.minecraft.cake": "тортъ",
  "block.minecraft.white_bed": "бѣлая постель",
  "block.minecraft.orange_bed": "оранжевая постель",
  "block.minecraft.magenta_bed": "пурпурная постель",
  "block.minecraft.light_blue_bed": "голубая постель",
  "block.minecraft.yellow_bed": "жёлтая постель",
  "block.minecraft.lime_bed": "яркозелёная постель",
  "block.minecraft.pink_bed": "розовая постель",
  "block.minecraft.gray_bed": "сѣрая постель",
  "block.minecraft.light_gray_bed": "свѣтлосѣрая постель",
  "block.minecraft.cyan_bed": "бирюзовая постель",
  "block.minecraft.purple_bed": "фіолетовая постель",
  "block.minecraft.blue_bed": "лазурная постель",
  "block.minecraft.brown_bed": "коричневая постель",
  "block.minecraft.green_bed": "зелёная постель",
  "block.minecraft.red_bed": "червонная постель",
  "block.minecraft.black_bed": "чёрная постель",
  "item.minecraft.cookie": "печенье",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "ножницы",
  "item.minecraft.melon_slice": "ломтикъ арбуза",
  "item.minecraft.dried_kelp": "сушёная ламинарія",
  "item.minecraft.pumpkin_seeds": "сѣмена тыквы",
  "item.minecraft.melon_seeds": "сѣмена арбуза",
  "item.minecraft.beef": "сырая говядина",
  "item.minecraft.cooked_beef": "жареная говядина",
  "item.minecraft.chicken": "курятина",
  "item.minecraft.cooked_chicken": "жареная курица",
  "item.minecraft.rotten_flesh": "прѣлая плоть",
  "item.minecraft.ender_pearl": "эндеръ-жемчугъ",
  "item.minecraft.blaze_rod": "огненный жезлъ",
  "item.minecraft.ghast_tear": "слеза гаста",
  "item.minecraft.gold_nugget": "кусочекъ золота",
  "item.minecraft.nether_wart": "нѣдрскій наростъ",
  "item.minecraft.potion": "несоздаваемое снадобье□безъ эффектовъ",
  "item.minecraft.glass_bottle": "бутылочка",
  "item.minecraft.spider_eye": "паучье око",
  "item.minecraft.fermented_spider_eye": "засоленное паучье око",
  "item.minecraft.blaze_powder": "огненный порошокъ",
  "item.minecraft.magma_cream": "сгустокъ магмы",
  "block.minecraft.brewing_stand": "варочная стойка",
  "block.minecraft.cauldron": "котёлъ",
  "item.minecraft.ender_eye": "око эндера",
  "item.minecraft.glistering_melon_slice": "сіяющій ломтикъ арбуза",
  "item.minecraft.bat_spawn_egg": "яйцо призыва летучей мыши",
  "item.minecraft.bee_spawn_egg": "яйцо призыва пчелы",
  "item.minecraft.blaze_spawn_egg": "яйцо призыва пламеня",
  "item.minecraft.cat_spawn_egg": "яйцо призыва кошки",
  "item.minecraft.cave_spider_spawn_egg": "яйцо призыва мизгиря",
  "item.minecraft.chicken_spawn_egg": "яйцо призыва курицы",
  "item.minecraft.cod_spawn_egg": "яйцо призыва трески",
  "item.minecraft.cow_spawn_egg": "яйцо призыва коровы",
  "item.minecraft.creeper_spawn_egg": "яйцо призыва крипера",
  "item.minecraft.dolphin_spawn_egg": "яйцо призыва дельфина",
  "item.minecraft.donkey_spawn_egg": "яйцо призыва осла",
  "item.minecraft.drowned_spawn_egg": "яйцо призыва утопленника",
  "item.minecraft.elder_guardian_spawn_egg": "яйцо призыва старѣйшаго сторожа",
  "item.minecraft.enderman_spawn_egg": "яйцо призыва эндермана",
  "item.minecraft.endermite_spawn_egg": "яйцо призыва эндермита",
  "item.minecraft.evoker_spawn_egg": "яйцо призыва чародѣя",
  "item.minecraft.fox_spawn_egg": "яйцо призыва лисицы",
  "item.minecraft.ghast_spawn_egg": "яйцо призыва гаста",
  "item.minecraft.guardian_spawn_egg": "яйцо призыва сторожа",
  "item.minecraft.hoglin_spawn_egg": "яйцо призыва хоглина",
  "item.minecraft.horse_spawn_egg": "яйцо призыва лошади",
  "item.minecraft.husk_spawn_egg": "яйцо призыва кадавра",
  "item.minecraft.llama_spawn_egg": "яйцо призыва ламы",
  "item.minecraft.magma_cube_spawn_egg": "яйцо призыва магмоваго куба",
  "item.minecraft.mooshroom_spawn_egg": "яйцо призыва муухомора",
  "item.minecraft.mule_spawn_egg": "яйцо призыва мула",
  "item.minecraft.ocelot_spawn_egg": "яйцо призыва оцелота",
  "item.minecraft.panda_spawn_egg": "яйцо призыва панды",
  "item.minecraft.parrot_spawn_egg": "яйцо призыва попугая",
  "item.minecraft.phantom_spawn_egg": "яйцо призыва фантома",
  "item.minecraft.pig_spawn_egg": "яйцо призыва свиньи",
  "item.minecraft.piglin_spawn_egg": "яйцо призыва пиглина",
  "item.minecraft.pillager_spawn_egg": "яйцо призыва разбойника",
  "item.minecraft.polar_bear_spawn_egg": "яйцо призыва бѣлаго медвѣдя",
  "item.minecraft.pufferfish_spawn_egg": "яйцо призыва иглобрюха",
  "item.minecraft.rabbit_spawn_egg": "яйцо призыва кролика",
  "item.minecraft.ravager_spawn_egg": "яйцо призыва разорителя",
  "item.minecraft.salmon_spawn_egg": "яйцо призыва лосося",
  "item.minecraft.sheep_spawn_egg": "яйцо призыва овцы",
  "item.minecraft.shulker_spawn_egg": "яйцо призыва шалкера",
  "item.minecraft.silverfish_spawn_egg": "яйцо призыва чешуйницы",
  "item.minecraft.skeleton_spawn_egg": "яйцо призыва скелета",
  "item.minecraft.skeleton_horse_spawn_egg": "яйцо призыва лошади-скелета",
  "item.minecraft.slime_spawn_egg": "яйцо призыва слизня",
  "item.minecraft.spider_spawn_egg": "яйцо призыва паука",
  "item.minecraft.squid_spawn_egg": "яйцо призыва осьминога",
  "item.minecraft.stray_spawn_egg": "яйцо призыва зимогора",
  "item.minecraft.strider_spawn_egg": "яйцо призыва лавомѣрки",
  "item.minecraft.trader_llama_spawn_egg": "яйцо призыва ламы коробейника",
  "item.minecraft.tropical_fish_spawn_egg": "яйцо призыва тропической рыбы",
  "item.minecraft.turtle_spawn_egg": "яйцо призыва черепахи",
  "item.minecraft.vex_spawn_egg": "яйцо призыва вредины",
  "item.minecraft.villager_spawn_egg": "яйцо призыва крестьянина",
  "item.minecraft.vindicator_spawn_egg": "яйцо призыва воздаятеля",
  "item.minecraft.wandering_trader_spawn_egg": "яйцо призыва коробейника",
  "item.minecraft.witch_spawn_egg": "яйцо призыва вѣдьмы",
  "item.minecraft.wither_skeleton_spawn_egg": "яйцо призыва визеръ-скелета",
  "item.minecraft.wolf_spawn_egg": "яйцо призыва волка",
  "item.minecraft.zoglin_spawn_egg": "яйцо призыва зоглина",
  "item.minecraft.zombie_spawn_egg": "яйцо призыва мертвеца",
  "item.minecraft.zombie_horse_spawn_egg": "яйцо призыва лошади-мертвеца",
  "item.minecraft.zombie_villager_spawn_egg": "яйцо призыва крестьянина-мертвеца",
  "item.minecraft.zombified_piglin_spawn_egg": "яйцо призыва пиглина-мертвеца",
  "item.minecraft.experience_bottle": "бутылочка мудрости",
  "item.minecraft.fire_charge": "огненный зарядъ",
  "item.minecraft.writable_book": "книга и перо",
  "item.minecraft.written_book": "завершённая книга",
  "item.minecraft.emerald": "смарагдъ",
  "item.minecraft.item_frame": "рамка",
  "block.minecraft.flower_pot": "цвѣточный горшокъ",
  "item.minecraft.carrot": "морковка",
  "item.minecraft.potato": "картофель",
  "item.minecraft.baked_potato": "запечённый картофель",
  "item.minecraft.poisonous_potato": "ядовитый картофель",
  "item.minecraft.map": "чистая карта",
  "item.minecraft.golden_carrot": "золотая морковь",
  "block.minecraft.skeleton_skull": "черепъ скелета",
  "block.minecraft.wither_skeleton_skull": "черепъ визеръ-скелета",
  "block.minecraft.player_head": "человѣческая голова",
  "block.minecraft.zombie_head": "голова мертвеца",
  "block.minecraft.creeper_head": "голова крипера",
  "block.minecraft.dragon_head": "голова змѣя",
  "item.minecraft.carrot_on_a_stick": "удочка съ морковкой",
  "item.minecraft.warped_fungus_on_a_stick": "удочка съ искажённымъ грибомъ",
  "item.minecraft.nether_star": "звѣзда нѣдра",
  "item.minecraft.pumpkin_pie": "тыквенный пирогъ",
  "item.minecraft.firework_rocket": "фейерверкъ",
  "item.minecraft.firework_star": "пиротехническая звѣзда",
  "item.minecraft.enchanted_book": "чародѣйская книга",
  "item.minecraft.nether_brick": "нѣдрскій кирпичъ",
  "item.minecraft.quartz": "нѣдрскій кварцъ",
  "item.minecraft.tnt_minecart": "взрывная вагонетка",
  "item.minecraft.hopper_minecart": "загрузочная вагонетка",
  "item.minecraft.prismarine_shard": "осколокъ призмарина",
  "item.minecraft.prismarine_crystals": "кристаллъ призмарина",
  "item.minecraft.rabbit": "сырая крольчатина",
  "item.minecraft.cooked_rabbit": "жареная крольчатина",
  "item.minecraft.rabbit_stew": "жаркое изъ кролика",
  "item.minecraft.rabbit_foot": "кроличья лапка",
  "item.minecraft.rabbit_hide": "кроличья шкурка",
  "item.minecraft.armor_stand": "стойка для брони",
  "item.minecraft.iron_horse_armor": "желѣзные конскіе доспѣхи",
  "item.minecraft.golden_horse_armor": "золотые конскіе доспѣхи",
  "item.minecraft.diamond_horse_armor": "діамантовые конскіе доспѣхи",
  "item.minecraft.leather_horse_armor": "кожаные конскіе доспѣхи",
  "item.minecraft.lead": "поводокъ",
  "item.minecraft.name_tag": "ярлыкъ",
  "item.minecraft.command_block_minecart": "вагонетка съ ариѳмометромъ",
  "item.minecraft.mutton": "сырая баранина",
  "item.minecraft.cooked_mutton": "жареная баранина",
  "block.minecraft.white_banner": "бѣлый флагъ",
  "block.minecraft.orange_banner": "оранжевый флагъ",
  "block.minecraft.magenta_banner": "пурпурный флагъ",
  "block.minecraft.light_blue_banner": "голубой флагъ",
  "block.minecraft.yellow_banner": "жёлтый флагъ",
  "block.minecraft.lime_banner": "яркозелёный флагъ",
  "block.minecraft.pink_banner": "розовый флагъ",
  "block.minecraft.gray_banner": "сѣрый флагъ",
  "block.minecraft.light_gray_banner": "свѣтлосѣрый флагъ",
  "block.minecraft.cyan_banner": "бирюзовый флагъ",
  "block.minecraft.purple_banner": "фіолетовый флагъ",
  "block.minecraft.blue_banner": "лазурный флагъ",
  "block.minecraft.brown_banner": "коричневый флагъ",
  "block.minecraft.green_banner": "зелёный флагъ",
  "block.minecraft.red_banner": "червонный флагъ",
  "block.minecraft.black_banner": "чёрный флагъ",
  "item.minecraft.end_crystal": "кристаллъ энда",
  "item.minecraft.chorus_fruit": "плодъ хоруса",
  "item.minecraft.popped_chorus_fruit": "жареный плодъ хоруса",
  "item.minecraft.beetroot": "свёкла",
  "item.minecraft.beetroot_seeds": "сѣмена свёклы",
  "item.minecraft.beetroot_soup": "борщъ",
  "item.minecraft.dragon_breath": "дыханіе змѣя",
  "item.minecraft.splash_potion": "взрывное несоздаваемое снадобье□безъ эффектовъ",
  "item.minecraft.spectral_arrow": "стрѣла наблюденія",
  "item.minecraft.tipped_arrow": "стрѣла, обработанная несоздаваемымъ снадобьемъ□безъ эффектовъ",
  "item.minecraft.lingering_potion": "несоздаваемое туманное снадобье□безъ эффектовъ",
  "item.minecraft.shield": "щитъ",
  "item.minecraft.elytra": "надкрылья",
  "item.minecraft.spruce_boat": "еловая лодка",
  "item.minecraft.birch_boat": "берёзовая лодка",
  "item.minecraft.jungle_boat": "лодка изъ тропическаго дерева",
  "item.minecraft.acacia_boat": "акаціевая лодка",
  "item.minecraft.dark_oak_boat": "лодка изъ тёмнаго дуба",
  "item.minecraft.totem_of_undying": "тотемъ безсмертія",
  "item.minecraft.shulker_shell": "панцырь шалкера",
  "item.minecraft.iron_nugget": "кусочекъ желѣза",
  "item.minecraft.knowledge_book": "книга знаній",
  "item.minecraft.debug_stick": "палка отладки",
  "item.minecraft.music_disc_13": "пластинка□c418 — 13",
  "item.minecraft.music_disc_cat": "пластинка□c418 — cat",
  "item.minecraft.music_disc_blocks": "пластинка□c418 — blocks",
  "item.minecraft.music_disc_chirp": "пластинка□c418 - chіrp",
  "item.minecraft.music_disc_far": "пластинка□c418 - far",
  "item.minecraft.music_disc_mall": "пластинка□c418 - mall",
  "item.minecraft.music_disc_mellohi": "пластинка□c418 - mellohі",
  "item.minecraft.music_disc_stal": "пластинка□c418 - stal",
  "item.minecraft.music_disc_strad": "пластинка□c418 - strad",
  "item.minecraft.music_disc_ward": "пластинка□c418 - ward",
  "item.minecraft.music_disc_11": "пластинка□c418 - 11",
  "item.minecraft.music_disc_wait": "пластинка□c418 - waіt",
  "item.minecraft.music_disc_pigstep": "пластинка□лена рейнъ — pіgstep",
  "item.minecraft.trident": "трезубецъ□□когда въ ведущей рукѣ:□+8 уронъ□-2.9 рѣзвость атаки",
  "item.minecraft.phantom_membrane": "мембрана фантома",
  "item.minecraft.nautilus_shell": "раковина наутилуса",
  "item.minecraft.heart_of_the_sea": "сердце моря",
  "item.minecraft.crossbow": "самострѣлъ",
  "item.minecraft.suspicious_stew": "диковинное рагу",
  "block.minecraft.loom": "ткацкій станокъ",
  "item.minecraft.flower_banner_pattern": "узоръ флага□цвѣтокъ",
  "item.minecraft.creeper_banner_pattern": "шаблонъ флага□рожица крипера",
  "item.minecraft.skull_banner_pattern": "узоръ флага□черепъ",
  "item.minecraft.mojang_banner_pattern": "узоръ флага□нѣчто",
  "item.minecraft.globe_banner_pattern": "узоръ флага□глобусъ",
  "item.minecraft.piglin_banner_pattern": "шаблонъ флага□рыло",
  "block.minecraft.composter": "компостница",
  "block.minecraft.barrel": "бочка",
  "block.minecraft.smoker": "коптильня",
  "block.minecraft.blast_furnace": "сыродутный горнъ",
  "block.minecraft.cartography_table": "картографическій столъ",
  "block.minecraft.fletching_table": "столъ лучника",
  "block.minecraft.grindstone": "точило",
  "block.minecraft.lectern": "каѳедра",
  "block.minecraft.smithing_table": "столъ кузнеца",
  "block.minecraft.stonecutter": "камнерѣзъ",
  "block.minecraft.bell": "колоколъ",
  "block.minecraft.lantern": "фонарь",
  "block.minecraft.soul_lantern": "фонарь душъ",
  "item.minecraft.sweet_berries": "сладкія ягоды",
  "block.minecraft.campfire": "костёръ",
  "block.minecraft.soul_campfire": "костёръ душъ",
  "block.minecraft.shroomlight": "грибосвѣтъ",
  "item.minecraft.honeycomb": "пчелиныя соты",
  "block.minecraft.bee_nest": "пчелиное гнѣздо",
  "block.minecraft.beehive": "пасѣка",
  "item.minecraft.honey_bottle": "бутылочка мёда",
  "block.minecraft.honey_block": "блокъ мёда",
  "block.minecraft.honeycomb_block": "блокъ пчелиныхъ сотъ",
  "block.minecraft.lodestone": "магнетитъ",
  "block.minecraft.netherite_block": "нѣдритовый блокъ",
  "block.minecraft.ancient_debris": "древніе обломки",
  "block.minecraft.target": "мишень",
  "block.minecraft.crying_obsidian": "плачущій обсидіанъ",
  "block.minecraft.blackstone": "чернокамень",
  "block.minecraft.blackstone_slab": "чернокаменная плита",
  "block.minecraft.blackstone_stairs": "чернокаменныя ступеньки",
  "block.minecraft.gilded_blackstone": "золочёный чернокамень",
  "block.minecraft.polished_blackstone": "полированный чернокамень",
  "block.minecraft.polished_blackstone_slab": "плита изъ полированнаго чернокамня",
  "block.minecraft.polished_blackstone_stairs": "ступеньки изъ полированнаго чернокамня",
  "block.minecraft.chiseled_polished_blackstone": "рѣзной полированный чернокамень",
  "block.minecraft.polished_blackstone_bricks": "полированные чернокаменные кирпичи",
  "block.minecraft.polished_blackstone_brick_slab": "плита изъ полированнаго чернокаменнаго кирпича",
  "block.minecraft.polished_blackstone_brick_stairs": "ступеньки изъ полированно-чернокаменнаго кирпича",
  "block.minecraft.cracked_polished_blackstone_bricks": "потрескавшіеся полированно-чернокаменные кирпичи",
  "block.minecraft.respawn_anchor": "якорь возрожденія",
}
export const rpr = items; 
